export default "__VITE_ASSET__f86adb6d__"